import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';

@pbi.Component({
    selector: 'linkmenu',
    templateUrl: './linkmenu.component.html'
})

export class LinkMenuComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: any[] = [];
    constructor(private adminSV: AdminService, private router: pbi.Router) {
        adminSV.changeLinkMN.subscribe(result => {
            let arrItems = result.url.split('/');
            let routerLink = '';
            for (var i = 0; i < arrItems.length; i++) {
                if (i > 0)
                    routerLink += '/' + arrItems[i];

                let Name = arrItems[i];
                if (Name == 'Admin') {
                    Name = 'Home';
                }
                Name = Name.charAt(0).toUpperCase() + Name.slice(1);
                if (Name) {
                    this.items.push(
                        { Name: Name, routerLink: routerLink }
                    );
                }
            }
        });
        adminSV.getLinkMeNu(router.url);
    }
    ngOnInit() {

    };
}


// WEBPACK FOOTER //
// ./src/app/admin/linkmenu/linkmenu.component.ts